import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {
  Customer,
  defaultJournalNumberSettings,
  JournalNumberSettings, PatternElement,
} from "../../../../core/models";
import {parsePattern, patternSample} from "../../../../core/helpers/pattern-utils";

@Component({
    selector: 'app-journal-no-settings',
    templateUrl: './journal-number-settings.component.html',
    styleUrls: ['./journal-number-settings.component.scss'],
    standalone: false
})
export class JournalNumberSettingsComponent implements OnInit, OnChanges {

  @Input() settings: JournalNumberSettings | undefined;
  @Output() saveSettings: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  customer: Customer;
  loading: boolean = false;
  value: JournalNumberSettings = {
    ...defaultJournalNumberSettings
  };
  form: FormGroup = new FormGroup({
    pattern: new FormControl<string>('', [Validators.required, Validators.pattern(/%<no>\d+d/)]),
    cutover_month: new FormControl<number>(0, [Validators.required, Validators.min(1), Validators.max(12)]),
    cutover_day: new FormControl<number>(0, [Validators.required, Validators.min(1), Validators.max(31)]),
    continuous_running_number: new FormControl<boolean>(false)
  });

  // internal housekeeping variables
  cutover: Date = new Date();
  pattern: PatternElement[] = [];
  sample: string;
  continuousRunningNumber: boolean = false;

  ngOnInit(): void {
    this.form.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['settings']) this.setPropertyValues(changes['settings'].currentValue);
  }

  doEdit(): void {
    this.form.enable();
  }

  doCancel(): void {
    this.value = { ...defaultJournalNumberSettings, ...this.settings };
    this.form.reset(this.value);
    this.form.disable();
  }

  doSave(): void {
    this.saveSettings.emit(this.form);
    this.setPropertyValues(this.form.value);
    this.form.disable();
  }

  onPatternChanged(newPattern: string): void {
    this.form.patchValue({ pattern: newPattern });
    this.form.updateValueAndValidity();
  }

  get patternCtrl(): FormControl<string> {
    return this.form.get('pattern') as FormControl<string>;
  }

  private setPropertyValues(settings: JournalNumberSettings): void {
    this.settings = settings;
    if (this.settings) {
      this.value = { ...defaultJournalNumberSettings, ...this.settings };
    }
    this.pattern = parsePattern(this.value.pattern);
    this.sample = patternSample(this.value.pattern, 'KAT')
    this.cutover.setMonth(this.value.cutover_month - 1);
    this.cutover.setDate(this.value.cutover_day);
    this.continuousRunningNumber = this.value.continuous_running_number;
    this.form.patchValue(this.value);
  }

}
